import Vue from "vue";
import queue from "queue";

import Upload from "@/helpers/Upload";

class Uploader {
  constructor() {
    this.queue = new queue({
      concurrency: 1,
      autostart: true,
    });

    this.queue.on("error", (err) => {
      console.log("[queue] error", err);
    });

    Vue.util.defineReactive(this, "uploads", []);
  }

  upload(file, options = {}) {
    const upload = new Upload(file, options);

    if (options.now) {
      upload.start();
    } else {
      // Add to uploads and return promise
      this.queue.push(() => upload.start());
    }

    if (!options.silently) {
      // Add to uploads list
      this.uploads.push(upload);
    }

    return upload;
  }

  findByKey(key) {
    return this.uploads.find((upload) => upload.options.key == key);
  }

  clear() {
    this.uploads.map((upload) => upload.cancel());
    this.uploads = [];
  }

  remove(upload) {
    const index = this.uploads.indexOf(upload);

    if (index >= 0) {
      this.uploads = this.uploads.filter((test) => test != upload);
    }
  }
}

export default new Uploader();



// WEBPACK FOOTER //
// ./src/services/Uploader.js